import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import Siding from "@/pages/services/Siding";

export const Route = createFileRoute("/_site/services/siding")({
  head: () => ({
    ...seo({
      title: "Siding Installation & Repair | Kodiak Structures & Exteriors",
      description:
        "Professional siding installation and repair throughout Minnesota. Vinyl, fiber cement, and engineered wood options. Free estimates.",
      path: "/services/siding",
    }),
  }),
  component: Siding,
});
